/*
 * @Author: 艾斯
 * @Date: 2019-12-06 16:18:42
 * @LastEditTime: 2019-12-06 18:15:40
 * @LastEditors: Please set LastEditors
 * @Description: 微信自定义分享
 * @FilePath: /vue/wei/src/wxsdk/share.js
 */
import wx from "weixin-js-sdk";
import axios from "axios";
function weixinshare(titles, linkurl, imgurls, descs) {
  const appId = "wxb9063d24cd9ab5f5";
  axios
    .get(
      `https://f.yuansiwei.com/index.php?r=api/wechatapi/getsignature&appId=${appId}&url=${window.location.href}`
    )
    .then(function(res) {
      if (res.data.success) {
        wxshare(res.data);
      }
    });

  function wxshare(data) {
    let timestamp = data.data.timestamp;
    let nonceStr = data.data.noncestr;
    let signature = data.data.signature;
    wx.config({
      beta: true,
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: appId, // 必填，公众号的唯一标识
      timestamp: timestamp, // 必填，生成签名的时间戳
      nonceStr: nonceStr, // 必填，生成签名的随机串
      signature: signature, // 必填，签名，见附录1
      // jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage", "closeWindow"]
    });

    wx.ready(function() {
      //分享朋友圈
      wx.onMenuShareTimeline({
        title: titles, // 分享标题
        link: linkurl, // 分享链接
        imgUrl: imgurls, // 分享图标
        success: function() {
          // 用户确认分享后执行的回调函数
        }
      });
      // 分享好友
      wx.onMenuShareAppMessage({
        title: titles, // 分享标题
        desc: descs, // 分享描述
        link: linkurl, // 分享链接
        imgUrl: imgurls, // 分享图标
        success: function() {}
      });
    });
  }
}

export default weixinshare;
